import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SitePage } from './site';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    SitePage,
  ],
  imports: [
    IonicPageModule.forChild(SitePage),
    ComponentsModule
  ],
})
export class SitePageModule {}



// WEBPACK FOOTER //
// ./src/pages/site/site.module.ts